import React from 'react';
import PropTypes from 'prop-types';
import styles from './index.css';
import errorBoundary from '@ifeng/errorBoundary';
import FormTitle from '@src/mobile/layout/Component/FormTitle';
import UploadVideo from './UploadVideo';
import UploadPic from './UploadPic';

const Media = ({ formData, setFormDataHandle, warningTextList, updateId, updateSuccess }) => {
    
    const changeInputHandle = (key, value) => {
        setFormDataHandle(key, value);
    };

    return (
        <div className={styles.media}>
            <FormTitle name="img" title="形象照片" warningText={warningTextList['img']} isRequired={true} />
            <div className={styles.picInfo}>面貌清晰的半身、全身各一张<br />图片仅支持jpeg、png、gif、jpg格式</div>
            <div className={styles.picList}>
                <UploadPic name="img1" formData={formData} changeInputHandle={changeInputHandle} updateId={updateId} updateSuccess={updateSuccess} />
                <UploadPic name="img2" formData={formData} changeInputHandle={changeInputHandle} updateId={updateId} updateSuccess={updateSuccess} />
            </div>
            <FormTitle name="video_self" title="自我介绍视频" warningText={warningTextList['video_self']} isRequired={true} />
            <div className={styles.picInfo}>请保证视频在1分钟以内、不使用美颜、不使用滤镜<br />视频仅支持mp4、mov、quicktime格式</div>
            <UploadVideo name="video_self" formData={formData} changeInputHandle={changeInputHandle} />
        </div>
    );
};

Media.propTypes = {
    formData: PropTypes.object,
    setFormDataHandle: PropTypes.func,
    warningTextList: PropTypes.object,
    updateId: PropTypes.string,
    updateSuccess: PropTypes.bool
};

export default errorBoundary(Media);
